import { UserResponse } from 'utils/GeneratedApi';

export type Section =
  | 'dashboard'
  | 'members'
  | 'content'
  | 'automation'
  | 'data'
  | 'analytics'
  | 'segments'
  | 'account_settings'
  | 'communications'
  | 'plans_and_products';

export function checkAdminAccess(user: UserResponse | undefined, sectionId?: Section): boolean {
  if (!user) return false;

  // As per our current implementation, tenant_admin type user has one role.
  // Ex: Each role can have different permissions.
  // So It's not guranateed that tenant_admin type user has access to all sections.
  const isAdminType = ['system_admin'].includes(user.userType);

  if (user.isOwner || isAdminType) return true;

  if (!user.permissions) return false;

  if (!sectionId) {
    return user.permissions.some((p) => p.readPermission || p.updatePermission);
  } else {
    return user.permissions.some(
      (p) => p.sectionId === sectionId && (p.readPermission || p.updatePermission),
    );
  }
}
